import React, { useState, useEffect } from "react";
import { Button } from "antd";
import RadioBox from "../components/forms/v-radio-box";
import "./styles/Welcome.less";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { setUserMode } from "../redux/auth/auth.action";
import { handleRouting } from "./helper/handleRoute";
import { setAlert } from "../redux/alert/alert.action";

function WelcomeLogin({ accessToken, user }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState("");

  const handleRadioChange = (e) => {
    setCustomer(e.target.value);
    dispatch(setUserMode(e.target.value));
  };

  const handleNext = () => {
    if (customer !== "") {
      customer === "client"
        ? navigate(`/client/signin`)
        : navigate(`/caregiver/signin`);
    } else {
      dispatch(
        setAlert({
          alertType: "error",
          alertMsg: "Please select any from Client or Caregiver/Companion",
          alertOpen: true,
        })
      );
    }
  };

  const typeOfCustomers = [
    {
      icon: (
        <img
          className="me-3"
          width={45}
          src="/images/icons/client.svg"
          alt="client icon"
        />
      ),
      activeIcon: (
        <img
          className="me-3"
          width={45}
          src="/images/icons/client_active.svg"
          alt="client icon"
        />
      ),
      name: "Client",
      value: "client",
    },
    {
      icon: (
        <img
          className="me-3"
          width={45}
          src="/images/icons/caregiver.svg"
          alt="caregiver icon"
        />
      ),
      activeIcon: (
        <img
          className="me-3"
          width={45}
          src="/images/icons/caregiver_bold.svg"
          alt="caregiver icon"
        />
      ),
      name: "Caregiver/Companion",
      value: "caregiver",
    },
  ];
  return (
    <div className="center-container main-div-top min-vh-100">
      <div className="welcome-container">
        <div className="left-side-poster welcome-poster" />
        <div className="right-side-form">
          <div className="center-container justify-content-start h-100">
            <div className="w-100">
              <img
                className="logo-img pt-0 mb-4 main-logo"
                src="./images/icons/logo_with_name.svg"
                alt="logo"
              />
              <h1 className="welcome-header mb-2">
                Welcome to <span id="name">MF Homecare.</span>
              </h1>
              <div className="full-width" style={{ maxWidth: "370px" }}>
                <p className="welcome-subheader mb-3">
                  Login as a . . .{/* {customer === '' ? ' ...' : customer} */}
                </p>
                <div className="mb-3 mt-5 radio-box-div">
                  <RadioBox
                    btnClass="p-3 mb-3 h-100 fs-5 fw-bold"
                    sufixStyle={{ width: 22 }}
                    options={typeOfCustomers}
                    value={customer}
                    defaultValue={"client"}
                    dir="vertical"
                    onChange={handleRadioChange}
                  />
                </div>
                <Button
                  className="btn-black btn-light ps-5 pe-5 home-button common-theme-btn"
                  onClick={() => handleNext()}
                  shape="round"
                  type="primary"
                  size="large"
                  disabled={customer === "" ? true : false}
                >
                  Confirm{" "}
                  <img
                    className="ms-2"
                    src="/images/icons/right.svg"
                    alt="right icon"
                  />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    alert: state.alert,
    userType: state.loginData?.user?.userType,
    screen: state.loginData?.user?.screen,
    accessToken: state.loginData?.user?.accessToken,
    user: state.loginData?.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeLogin);
